import { useDispatch, useSelector } from "react-redux";
import {
  useGetEarningRedemptionListDataQuery,
  useUpdateEarningRedemptionTableHeadDataMutation,
} from "../../../store/queries/Report";
import { updateConfig } from "../../../store/slices/Report/earningRedemptionSlice";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import { useState } from "react";
import { toast } from "react-toastify";
import { getEarningRedemptionExportedData } from "../api";
import { getFormatedDate } from "../../../utils/Functions/table";
import { Tooltip as ReactTooltip } from "react-tooltip";

const useEarningAndRedemption = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const dispatch = useDispatch();
  const [isExcelLinkSend, setIsExcelLinkSend] = useState(false);
  const { tableFields, showEditModal } = useSelector((state) => state.global);
  const earningRedemptionState = useSelector(
    (state) => state.earningRedemption
  );
  const {
    data: earningRedemptionList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetEarningRedemptionListDataQuery({
    page_size: earningRedemptionState?.currentPageSize,
    page: earningRedemptionState?.currentPage,
    sort: earningRedemptionState?.sortBy,
    sort_order: earningRedemptionState?.sortOrder,
    search: earningRedemptionState?.search,
    start_date: getFormatedDate(earningRedemptionState?.startDate),
    end_date: getFormatedDate(earningRedemptionState?.endDate),
  });
  const [updateEarningRedemptionFields] =
    useUpdateEarningRedemptionTableHeadDataMutation();
  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e?.target?.value;
        state.currentPage = 1;
      })
    );
  };
  const [date, setDate] = useState({
    startDate: earningRedemptionState.startDate,
    endDate: earningRedemptionState.endDate,
    key: "selection",
  });

  const handleClearClick = () => {
    dispatch(updateConfig((state) => (state.search = "")));
  };

  const handleSort = (label) => {
    if (earningRedemptionState?.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder =
            earningRedemptionState?.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

  const getRow = (feild, data) => {
    const rows = {
      common: (feild, data) => <p className="pro-mb-0">{data[feild]}</p>,
      formated_reward_amount: (field, data) => {
        return (
          <>
            <p
              className="pro-mb-0"
              data-tooltip-id={`reward-amount-${data?.name}`}
            >
              {data[field]}
            </p>
            <ReactTooltip
              id={`reward-amount-${data?.name}`}
              place="left"
              content={`Reward Amount : ${data?.reward_amount}`}
            />
          </>
        );
      },
      formated_purchased_amount: (field, data) => {
        return (
          <>
            <p
              className="pro-mb-0"
              data-tooltip-id={`purchased-amount-${data?.name}`}
            >
              {data[field]}
            </p>
            <ReactTooltip
              id={`purchased-amount-${data?.name}`}
              place="left"
              content={`Purchased Amount : ${data?.purchased_amount}`}
            />
          </>
        );
      },
    };
    return rows?.[feild]?.(feild, data) ?? rows["common"](feild, data);
  };

  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };
  const handleEarningRedemptionExcelDownload = () => {
    dispatch(
      updateConfig((state) => {
        state.earningRedemptionExcelSendModal =
          !state.earningRedemptionExcelSendModal;
      })
    );
  };
  const modalClose = () => {
    dispatch(
      updateConfig((state) => {
        state.earningRedemptionExcelSendModal = false;
      })
    );
  };
  const handleDateChange = (range) => {
    setDate(range);
    dispatch(
      updateConfig((state) => {
        state.currentPage = 1;
        state.startDate = range.startDate;
        state.endDate = range.endDate;
      })
    );
  };
  const handleDateRangeChange = (range) => {
    const startDate = range[0];
    const endDate = range[1];

    setDate({
      startDate,
      endDate,
    });

    dispatch(
      updateConfig((state) => {
        state.currentPage = 1;
        state.startDate = startDate;
        state.endDate = endDate;
      })
    );
  };
  const sendExcelData = async (value) => {
    setIsExcelLinkSend(true);
    let params = {
      email: value?.email ?? "",
      start_date: getFormatedDate(earningRedemptionState.startDate ?? ""),
      end_date: getFormatedDate(earningRedemptionState.endDate ?? ""),
      sort: earningRedemptionState?.sortBy,
      sort_order: earningRedemptionState?.sortOrder,
    };
    let response = await getEarningRedemptionExportedData(params);
    try {
      if (response?.status === 200) {
        toast.success(`Excel download link send successfully`);
      } else {
        toast.error(`Failed to send download link,Please try again`);
      }
    } catch (error) {
      console.error("Failed to send link:", error);
      toast.error(`Failed to send download link`);
    } finally {
      modalClose();
      setIsExcelLinkSend(false);
    }
  };

  return {
    date,
    isLoading,
    isFetching,
    tableFields,
    showEditModal,
    isExcelLinkSend,
    paginationOptions,
    earningRedemptionList,
    earningRedemptionState,
    handleEarningRedemptionExcelDownload,
    updateEarningRedemptionFields,
    handleEditColumnsClick,
    handleDateRangeChange,
    handleDateChange,
    handlePagination,
    handleClearClick,
    handlePageSize,
    sendExcelData,
    handleSearch,
    modalClose,
    handleSort,
    refetch,
    getRow,
  };
};

export default useEarningAndRedemption;
